import React, { useState, useEffect, useRef } from "react";
import { TESTIMONIALS } from "../data/siteData";

export default function ReviewSlider() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const total = TESTIMONIALS.length;

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev === 0 ? total - 1 : prev - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev === total - 1 ? 0 : prev + 1));
  };

  return (
    <section className="py-16 sm:py-24 bg-slate-50 text-slate-900 overflow-hidden relative border-t border-slate-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Header with Title and Desktop Navigation Arrows */}
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12">
          <div className="max-w-2xl">
            <h2 className="text-2xl sm:text-4xl font-extrabold tracking-tight text-slate-900 uppercase">
              Hvad siger vores kunder?
            </h2>
            <p className="mt-3 text-slate-600 text-sm sm:text-base">
              Kunderne vælger os for den stabile kvalitet, de faste priser og den hurtige respons. Her er et par ord fra dem, der allerede får pudset deres vinduer af NF-Polering.
            </p>
          </div>

          {/* Navigation Arrows for top/desktop */}
          <div className="flex items-center gap-3 self-start md:self-auto">
            <button
              onClick={handlePrev}
              aria-label="Forrige anmeldelse"
              className="w-12 h-12 rounded-full bg-white hover:bg-slate-900 hover:text-white text-slate-800 flex items-center justify-center transition-all shadow-sm focus:outline-none focus:ring-2 focus:ring-slate-400 active:scale-95 border border-slate-200"
            >
              <i className="fa-solid fa-chevron-left text-base" aria-hidden="true" />
            </button>
            <button
              onClick={handleNext}
              aria-label="Næste anmeldelse"
              className="w-12 h-12 rounded-full bg-white hover:bg-slate-900 hover:text-white text-slate-800 flex items-center justify-center transition-all shadow-sm focus:outline-none focus:ring-2 focus:ring-slate-400 active:scale-95 border border-slate-200"
            >
              <i className="fa-solid fa-chevron-right text-base" aria-hidden="true" />
            </button>
          </div>
        </div>

        {/* Carousel Content */}
        <div className="relative">
          {/* Desktop Grid Layout (all cards) */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
            {TESTIMONIALS.map((item, idx) => {
              return (
                <div
                  key={idx}
                  onClick={() => setCurrentIndex(idx)}
                  className="rounded-2xl p-6 sm:p-8 flex flex-col justify-between bg-white border border-slate-200 shadow-sm transition-all duration-300 hover:shadow-md"
                >
                  <div>
                    {/* Stars */}
                    <div className="flex items-center gap-1.5 text-amber-400 mb-5">
                      {[...Array(item.stars || 5)].map((_, i) => (
                        <i key={i} className="fa-solid fa-star text-sm" aria-hidden="true" />
                      ))}
                    </div>

                    {/* Quote */}
                    <blockquote className="text-slate-700 text-sm sm:text-base leading-relaxed italic">
                      "{item.quote}"
                    </blockquote>
                  </div>

                  {/* Customer author info */}
                  <div className="mt-8 pt-5 border-t border-slate-100 flex items-center gap-3.5">
                    <div>
                      <div className="font-bold text-slate-900 text-base">
                        {item.author}, {item.location}
                      </div>
                      <div className="text-xs text-slate-500 font-medium flex items-center gap-1 mt-0.5">
                        <i className="fa-solid fa-circle-check text-[10px] text-slate-900" aria-hidden="true" />
                        <span>Verificeret kunde</span>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          {/* Dots Indicator */}
          <div className="flex items-center justify-center gap-2 mt-8 md:hidden">
            {TESTIMONIALS.map((_, idx) => (
              <button
                key={idx}
                onClick={() => setCurrentIndex(idx)}
                aria-label={`Gå til anmeldelse ${idx + 1}`}
                className={`h-2.5 rounded-full transition-all ${
                  idx === currentIndex ? "w-8 bg-cyan-600" : "w-2.5 bg-slate-300"
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
